import {nanoid} from 'nanoid';

import * as Mousetrap from 'mousetrap';
import {useEffect} from 'react';

export const getIdForNextElement = () => nanoid();

export function useMousetrap(keys, callback) {
  useEffect(() => {
    Mousetrap.bind(keys, callback);

    return () => Mousetrap.unbind(keys, callback);
  }, [keys, callback]);
}

export const getUrlParam = name => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(name);
};

export const getColor = data => {
  if (Object.keys(data).includes('r')) {
    return Object.keys(data).includes('a')
      ? `rgba(${data.r},${data.g},${data.b},${data.a})`
      : `rgb(${data.r},${data.g},${data.b})`;
  } else {
    return data;
  }
};

export const addStylesLink = url => {
  const link = document.createElement('link');

  link.href = url;
  link.type = 'text/css';
  link.rel = 'stylesheet';
  document.querySelectorAll('head')[0].append(link);
};

export const fileNameToAltText = fileName => {
  const withoutFilename = fileName.split('.')[0];
  const words = withoutFilename.split(/[_-]/);

  return words.join(' ');
};
